var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"quality"}},[_c('SfBreadcrumbs',{staticClass:"breadcrumbs",attrs:{"breadcrumbs":_vm.breadcrumbs}}),_c('OrkCmsPage',{attrs:{"page-id":"son_histoire_et_ses_hommes"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }